<template lang="pug">
.sector-info
	.side(v-if='false && pathways')
		.icon.icon-toggle(@click='toggleSideMenu')
		.sector(v-if='sector')
			.title
				img(v-if='sector.iconURL' :src='sector.iconURL')
				h2 {{ sector.name }}
			//- .description
			//- 	p {{ sector.description }}
		.pathways
			p.header Pathways
			.pathway(v-for='pathway in pathways')
				p.name {{ pathway.name }}
				.pathway-options
					p(@click='toggleDescription( pathway.name )') {{ isDescriptionOpen[pathway.name] ? 'hide' : 'full' }} description
					//- .dot
					//- p(@click='viewPathwayCourses( pathway.id )') view courses
				.pathway-description(:class='{ open : isDescriptionOpen[pathway.name] }')
					p(v-html='pathway.description')
	iframe.pdf-viewer(v-if='pdfURL' :src='pdfURL')
	.no-pdf(v-else)
		h1 No PDF uploaded for this CTE Sector
		.button(@click='goBack') Go Back
</template>

<script>
import Vue from 'vue';
import { Ref } from '@/lib/db';

// TODO: Remove dead code

export default {
  name : 'sector-info',

  data : () => ( {
    sectorCard        : null, // Info on the cte Cards. fileURL, iconURL
    isDescriptionOpen : {} // Keeps track of which pathway descriptions are showing
  } ),

  computed : {
    filters() {
      return this.$store.state.filters;
    },
    schoolID() {
      return this.$route.query.schoolID;
    },
    sectorID() {
      return this.$route.query.sectorID;
    },
    sector() {
      const s = this.$store.getters.getIndustrySectorByID( this.sectorID );
      return s;
    },
    school() {
      const s = this.$store.getters.getSchoolByID( this.schoolID );
      return s;
    },

    pathways() {
      const p = this.$store.getters.getCTEPathwaysBySector( this.sectorID );
      return p;
    },

    // If the schoolID is set to "All", then the pdfURL is located on the industry sector object
    // Otherwise, it's located on the school object
    pdfURL() {
      if ( this.schoolID === 'All' ) {
        return this.sector ? this.sector.pdfURL : '';
      }
      return this.school ? this.school.industrySectors[this.sectorID].pdfURL : '';
    }
  },

  watch : {
    sectorID() {
      const { sectorID } = this;

      Ref
        .child( 'industrySectors' )
        .child( sectorID )
        .once( 'value' )
        .then( ( snapshot ) => {
          this.sectorCard = snapshot.val();
        } );

      // Ref
      // 	.child( 'cteSectors' )
      // 	.child( sectorName )
      // 	.once( 'value' )
      // 	.then( ( snapshot ) => {
      // 		this.sector = snapshot.val();
      // 	} );

      // Ref
      // 	.child( 'ctePathways' )
      // 	.orderByChild( 'sector' )
      // 	.equalTo( sectorName )
      // 	.once( 'value' )
      // 	.then( ( snapshot ) => {
      // 		this.pathways = snapshot.val();
      // 	} );
    },
  },

  methods : {
    toggleDescription( pathwayName ) {
      const isOpen = !!this.isDescriptionOpen[pathwayName];

      Vue.set( this.isDescriptionOpen, pathwayName, !isOpen );
    },

    // Set filters to follow this pathway for this school, and navigate to /courses
    // viewPathwayCourses( pathwayID ) {
    //   // console.log( 'navigating to', pathwayID );
    //   // // const schoolFilter = this.filters.find( ( filter ) => {
    //   // // 	const { type } = filter;

    //   // // 	if ( type !== 'list' && type !== 'multi-list' ) {
    //   // // 		return false;
    //   // // 	}

    //   // // 	return filter.options.find( option => option.value === this.schoolName );
    //   // // } );

    //   // const pathwayFilter = this.filters.find( ( filter ) => {
    //   // 	const { type } = filter;

    //   // 	if ( type !== 'list' && type !== 'multi-list' ) {
    //   // 		return false;
    //   // 	}

    //   // 	return filter.options.find( option => option.value === pathwayName );
    //   // } );

    //   // const query = ( () => {
    //   // 	const obj = {};
    //   // 	// if ( schoolFilter ) {
    //   // 	// 	query[schoolFilter.key] = this.schoolName;
    //   // 	// }

    //   // 	if ( pathwayFilter ) {
    //   // 		obj[pathwayFilter.key] = pathwayName;
    //   // 	}

    //   // 	obj.fromSectorInfo = true;

    //   // 	return obj;
    //   // } )();

    //   // this.$router.push( {
    //   // 	path : 'courses',
    //   // 	query,
    //   // } );
    // },

    goBack() {
      this.$router.push( 'cte' );
    },

    toggleSideMenu() {
      this.$store.dispatch( 'toggleSideMenu' );
    }
  }

};
</script>

<style lang="scss" scoped>
.sector-info {
	height: 100vh;
	display: flex;
	flex-direction: column;
	overflow: auto;

	@include md {
		flex-direction: row;
	}

	.side {
		position: relative;
		width: 100%;

		@include md {
			width: 350px;
			height: 100%;
			overflow: auto;
		}

		.icon-toggle {
			position: absolute;
			left: 10px;
			top: 10px;
		}

		.sector {
			margin: 30px 15px;

			.title {
				display: flex;
				flex-direction: column;
				align-items: center;

				h2 {
					color : $primary;
					text-align: center;
				}

				img, .no-icon {
					height: 100px;
					width: 100px;
					border-radius: 50%;
					margin-bottom: 15px;
				}

				p {
					font-size: 20px;
				}
			}

			.description {
				margin: 25px 15px;
			}
		}

		.pathways {
			overflow: auto;

			p.header {
				margin-left: 15px;
				margin-bottom : 15px;
				font-weight: 600;
				font-size: 20px;
				color: $primary;
			}

			.pathway {
				border-top: 1px solid $lightGrey;
				padding : 20px 15px;

				&:last-child {
					border-bottom: 1px solid $lightGrey;
				}

				.name {
					font-weight: 600;
				}

				.pathway-options {
					display: flex;
					align-items: center;
					margin-top: 5px;


					p {
						cursor: pointer;
						text-transform: uppercase;
						letter-spacing: 3px;
						font-size: 12px;
					}

					.dot {
						margin: 0px 10px;
						width: 5px;
						height: 5px;
						border-radius: 50%;
						background-color: $primary;
					}
				}

				.pathway-description {
					display: none;
					margin-top: 20px;

					&.open {
						display: flex;
					}
				}
			}
		}
	}

	.pdf-viewer {
		min-height: 500px;
		height: 100%;
		flex: 1 1 0;
		padding: 30px;
		background: #444;
		@include md {
			padding: 0;
		}
	}

	.no-pdf {
		display: flex;
		height: 100%;
		flex: 1 1 0;
		background :#d0d1db;
		flex-direction: column;
		justify-content: center;
		align-items: center;

		h1 {
			color: $primary;
			font-size: 36px;
			margin-bottom: 15px;
		}

		.button {
			font-size: 24px;
		}
	}
}

@media only screen and ( min-width : 993px ) {
	.icon-toggle {
		opacity: 0;
		pointer-events: none;
	}
}
</style>
